import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import type { RootState } from "@js/store";

type ReviewsModalAutoOpensState = {
  autoOpenJobReviewsModal: boolean;
  showWriteReviewFormAfterOpenReviewsModal: boolean;
};

const initialState: ReviewsModalAutoOpensState = {
  autoOpenJobReviewsModal: false,
  showWriteReviewFormAfterOpenReviewsModal: false,
};

export const reviewsModalAutoOpenSlice = createSlice({
  name: "reviewsModalsAutoOpenSlice",
  initialState,
  reducers: {
    setAutoOpenJobReviewsModal(state, action: PayloadAction<boolean>) {
      state.autoOpenJobReviewsModal = action.payload;
    },
    showWriteReviewFormAfterOpen(state, action: PayloadAction<boolean>) {
      state.showWriteReviewFormAfterOpenReviewsModal = action.payload;
    },
  },
});

export const { setAutoOpenJobReviewsModal, showWriteReviewFormAfterOpen } =
  reviewsModalAutoOpenSlice.actions;

export const getShouldAutoOpenJobReviewsModal = (state: RootState) =>
  state.reviewsModals.autoOpenJobReviewsModal;

export const getShouldShowWriteReviewFormAfterOpenReviewsModal = (
  state: RootState,
) => state.reviewsModals.showWriteReviewFormAfterOpenReviewsModal;
